import React from 'react';
import { Modal, ModalProps, useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';

import Button from './Button';
import { H5, P } from './Typography';

const StyledDimContainer = styled.View`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
`;

const StyledDialog = styled.View<{ isDesktop: boolean }>`
  width: 90%;
  max-width: ${p => (p.isDesktop ? 480 : 420)}px;
  border-radius: 10px;
  overflow: hidden;
  background-color: white;
  padding: 40px 24px 24px 24px;
  align-items: center;
`;

const StyledButtonContainer = styled.View`
  max-width: 280px;
  width: 100%;
`;

export type AlertDialogProps = ModalProps & {
  title: string;
  message: string;
  closeLabel?: string;
  onCloseClicked?: () => void;
};

const AlertDialog: React.FC<AlertDialogProps> = ({
  title,
  message,
  closeLabel = 'Ok',
  onCloseClicked,
  ...props
}) => {
  const window = useWindowDimensions();
  const isDesktop = window.width >= 768;
  return (
    <Modal animationType='fade' transparent {...props}>
      <StyledDimContainer>
        <StyledDialog isDesktop={isDesktop}>
          <H5 color='dark' padding={3} center>
            {title}
          </H5>
          <P padding={4} center>
            {message}
          </P>
          <StyledButtonContainer>
            <Button outlined fullWidth size='small' onPress={onCloseClicked}>
              {closeLabel}
            </Button>
          </StyledButtonContainer>
        </StyledDialog>
      </StyledDimContainer>
    </Modal>
  );
};

export default AlertDialog;
